import * as React from 'react';

import { ChatContainer } from '../../containers/ChatContainer';
import { ComparisonNotificationContainer } from '../../containers/ComparisonNotificationContainer';
import { ErrorContainer } from '../../containers/ErrorContainer';
import { FiltersContainer, FiltersDesktopContainer } from '../../containers/Filters';
import { FoldersNotificationContainer } from '../../containers/FoldersNotificationContainer';
import { MapModalContainer } from '../../containers/MapModalContainer';
import { NotificationContainer } from '../../containers/Notifications';
import { ResultsContainer } from '../../containers/Results';
import { SettingsModalContainer } from '../../containers/ShareSettingsModal';

export function Page() {
  return (
    <>
      <FiltersContainer />
      <ResultsContainer />
      <NotificationContainer />
      <FiltersDesktopContainer />
      <FoldersNotificationContainer />
      <SettingsModalContainer />
      <ComparisonNotificationContainer />
      <MapModalContainer />
      <ChatContainer type="short" />
      <ErrorContainer />
    </>
  );
}
